<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>系统设置</el-breadcrumb-item>
        <el-breadcrumb-item>辅助工具</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- start -->
      <el-tab-pane name="first" label="辅助工具">
        <el-card class="box-card">
        <el-form :model="dataForm" ref="dataFormRef" label-width="170px">
          <el-form-item label="输入字符串" class="addAdminForm">
            <el-input v-model="dataForm.input" placeholder="请输入字符串"></el-input>
          </el-form-item>

          <el-form-item label="输出字符串" class="addAdminFormLongLong">
            <el-input type="textarea" v-model="dataForm.output" placeholder=""></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="funaddrole">DES加密</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="apiGetjigoutreeid">机构树</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="apiAuxiliaryToolWorkWeixinMessageText">发送企业微信</el-button>
          </el-form-item>
        </el-form>
        </el-card>
      </el-tab-pane>
      <!-- end -->
    </el-tabs>
  </div>
</template>

<script>
// import { encryptionCode } from '@/plugins/des.js'
import MD5Encrypt from 'js-md5'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  name: 'MyRole',
  data () {
    return {
      activeName: 'first',
      dataForm: {
        input: '',
        output: ''
      }
    }
  },
  mounted () {
  },
  methods: {
    funaddrole () {
      this.dataForm.output = MD5Encrypt(this.dataForm.input).substr(16, 8).toUpperCase() + ':'
    },
    apiGetjigoutreeid: function () {
      var that = this
      that.dataForm.output = ''
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouid: that.dataForm.input
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Getjigoutreeid, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataForm.output = response.data.Rv
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAuxiliaryToolWorkWeixinMessageText: function () {
      var that = this
      that.dataForm.output = ''
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        content: that.dataForm.input
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AuxiliaryToolWorkWeixinMessageText, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataForm.output = response.data.Rv
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.el-tree{
  height: 350px;
  overflow-y: scroll
}
.el-tree::-webkit-scrollbar {
    display: none;
}
</style>
